<form [formGroup]="form" (ngSubmit)="formSubmit()">
  <div class="d-flex justify-content-between align-items-center my-2">
    <div class="d-flex align-items-center">
      <div class="card-sub-heading  bold">Dimension/Weight</div>
    </div>
    <button mat-icon-button (click)="this.dialogRef.close()" type="button">
      <img src="assets/images/icons/grey_cross_icon.png" alt="close icon" />
    </button>
  </div>
  <div class="mt-3 row">
    <div class="col-md-10">
    <input
      type="number"
      class="form-control w-100"
      placeholder="Enter Weight"
      formControlName="Weight"
      (change)="validateInput('Weight')"
    />
    <app-error-message
      [formName]="form"
      [fieldName]="'Weight'"
      [type]="'group'"
    >
    </app-error-message>
  </div>
  <div class="col-md-2 mt-2">
    <label>kg</label>
  </div>
</div>

<div class="mt-3 row">
  <div class="col-md-10">
    <input
      type="number"
      class="form-control w-100"
      placeholder="Enter Length"
      formControlName="Height"
      (change)="validateInput('Height')"
    />
    <app-error-message
      [formName]="form"
      [fieldName]="'Height'"
      [type]="'group'"
    >
    </app-error-message>
  </div>
  <div class="col-md-2 mt-2">
    <label>cm</label>
  </div>
</div>

<div class="mt-3 row">
  <div class="col-md-10">
    <input
      type="number"
      class="form-control w-100"
      placeholder="Enter Width"
      formControlName="Width"
      (change)="validateInput('Width')"
    />
    <app-error-message [formName]="form" [fieldName]="'Width'" [type]="'group'">
    </app-error-message>
  </div>
  <div class="col-md-2 mt-2">
    <label>cm</label>
  </div>
</div>

<div class="mt-3 row">
  <div class="col-md-10">
    <input
      type="number"
      class="form-control w-100"
      placeholder="Enter Height"
      formControlName="Length"
      (change)="validateInput('Length')"
    />
    <app-error-message
      [formName]="form"
      [fieldName]="'Length'"
      [type]="'group'"
    >
    </app-error-message>
  </div>
  <div class="col-md-2 mt-2">
    <label>cm</label>
  </div>
</div>

  <div class="d-flex mt-4">
    <div class="col-md-12 d-flex justify-content-end">
      <button
        class="custom-btn "
        (click)="dialogRef.close()"
        type="button"
      >
        Cancel
      </button>
      <button class="custom-btn" type="submit">
        Save
        <span class="whiteLoader" *ngIf="isLoading"></span>
      </button>
    </div>
  </div>
</form>
